<template>
  <div id="app">
    <Header />
    <router-view id="main-main" />
    <Footer />
    <Modal>
      <component :is="$store.state.modal.component" :content="$store.state.modal.content" />
    </Modal>
  </div>
</template>

<script>
import Store from '@/store';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Modal from '@/components/Modal';

// import Resources from '@/components/content/Resources';

export default {
  components: {Header, Footer, Modal},

  data() {
    return {
      store: Store,
      // comp: Resources,
    }
  },

  created() {
    // this.$store.commit('modal/setComponent', Footer);
    Store.commit('modal/setContent', null);

  },
}
</script>

<style lang="scss">
@import '@/sass/main';
</style>
